import { render, staticRenderFns } from "./CorporativeActivityBankStatements.vue?vue&type=template&id=3de32c0a"
import script from "./CorporativeActivityBankStatements.vue?vue&type=script&lang=js"
export * from "./CorporativeActivityBankStatements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports